import React from 'react';
import clsx from 'clsx';

const Option = ({ option, isSelected, onSelect }) => {
  return (
    <div
      className={clsx(
        'flex items-center gap-3 px-4 py-2 hover:bg-gray-50 cursor-pointer text-gray-700',
        isSelected && 'bg-primary-50 hover:bg-primary-100'
      )}
      onClick={() => onSelect(option)}
    >
      <input
        type="checkbox"
        checked={isSelected}
        onChange={() => {onSelect(option)}}
        className="h-4 w-4 text-primary-600 rounded border-gray-300 focus:ring-primary-500 cursor-pointer"
        onClick={(e) => {
          e.stopPropagation();
          onSelect(option);
        }}
      />
      <span className="flex-1">{option.label}</span>
    </div>
  );
};

export default Option;